export function debounce<T extends (...args: any[]) => Promise<void> | void>(fn: T, delay: number) {
  let timerId: ReturnType<typeof setTimeout>;

  return function (...args: Parameters<T>): void {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      const result = fn(...args);
      if (result instanceof Promise) {
        result.catch((error) => {
          console.error("Debounce error:", error);
        });
      }
    }, delay);
  };
}
